import {Component, Input} from '@angular/core';
import {NgStyle} from "@angular/common";

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.css',
  imports: [
    NgStyle
  ],
  standalone: true
})
export class SpinnerComponent {
  @Input() color: string = '';

}
